/**
 * Utility mixin which checks if the user is on a mobile (simply based o device width)
 *
 * @type {{data(): {windowWidth: number}, computed: {isMobile(): boolean}, methods: {onResize(): void}, mounted(): void}}
 */
export const isMobile = {
    data() {
        return {
            windowWidth: window.innerWidth
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },
    computed: {
        /**
         * true/false if the user is on a mobile sized device
         * @returns {boolean}
         */
        isMobile() {
            return this.windowWidth <= 767;
        }
    },
    methods:{
        /**
         * Checks for the window size i.e. to see if we are looking at mobile
         */
        onResize() {
            this.windowWidth = window.innerWidth
        }
    }
};



// WEBPACK FOOTER //
// ./src/Assets/components/Utility/mixins/isMobile.js